import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ApiService from '../util/ApiService';
import { Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import CustomSelect from "../util/CustomSelect";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./assets/css/Contact.css";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";

const ContactModal = ({ show, onHide, select, officerData = {}, onSaveSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        message: '',
        subject: '',
        priority_id: null,
        sector_id: null
    });



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        try {

            setLoading(true);
            const payload = {
                ...formData,
                priority_id: formData.priority_id?.value || null,
                sector_id: formData.sector_id?.value || null
            };

            const response = await ApiService.send(
                'post',
                `${process.env.REACT_APP_URL_API}contact`,
                payload,
                true
            ).then((response) => {

                if (response?.code === 200) {

                    const {data} = ApiService.handleApiResponse(response);


                    const protocolId = data.id;
                    const formattedDate = dayjs(response?.data.created_at).locale("pt-br").format("DD/MM/YYYY HH:mm");

                    Swal.fire({
                        title: "Sucesso!",
                        text: `Protocolo: #${protocolId}\nData: ${formattedDate}`,
                        icon: "success",
                        confirmButtonText: "OK",
                    }).then(() => {
                        onHide(true);
                    });

                } else {
                    throw new Error(response?.data?.message || 'Erro ao salvar funcionário.');
                }
            });
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Novo Help Desk</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row">
                        <CustomSelect
                            label="Prioridade"
                            className="col-3"
                            options={select.priorities || []}
                            value={formData.priority_id}
                            onChange={(selected) => setFormData({
                                ...formData,
                                priority_id: selected || null
                            })}
                        />

                        <CustomSelect
                            label="Setores"
                            className="col-3"
                            options={select.sectors || []}
                            value={formData.sector_id}
                            onChange={(selected) => setFormData({
                                ...formData,
                                sector_id: selected || null
                            })}
                        />

                        <div className="form-group col-6">
                            <label>Assunto</label>
                            <input
                                type="text"
                                className="form-control"
                                name="subject"
                                value={formData.subject || ''}
                                onChange={handleInputChange}
                                placeholder="Assunto do help desk"
                            />
                        </div>
                    </div>

                    <div className="form-group col-12">
                        <label>Mensagem</label>
                        <ReactQuill
                            theme="snow"
                            value={formData.message || ""}
                            onChange={(content) => setFormData({ ...formData, message: content })}
                            placeholder="Digite o texto da mensagem..."
                            className="custom-quill mb-5"
                            modules={{
                                toolbar: [
                                    [{ header: [1, 2, false] }],
                                    ["bold", "italic", "underline"],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    ["link"],
                                    ["clean"]
                                ],
                            }}
                            formats={[
                                "header", "bold", "italic", "underline",
                                "list", "bullet", "link", "image"
                            ]}
                        />
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary"  onClick={() =>onHide()}>
                   <i className="fa fa-close"></i> Cancelar
                </Button>
                <Button variant="primary"  onClick={() =>handleSave()} disabled={loading}>
                    {loading ? (
                        <>
                    <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                    ></span>
                            Salvando...
                        </>
                    ) : (
                        <><i className="fa fa-plus"></i> Cadastrar</>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ContactModal;
